import React from 'react';
import './Dashboard.css';

// `can` má výchozí hodnotu, aby dlaždice zůstaly vidět, kdyby komponentu
// někdo vykreslil bez oprávnění. Skrytí je kosmetika — sekci hlídá backend.
function Dashboard({ openTab, can = () => true }) {
  const handleOpenOrders = () => {
    openTab('orders', 'Seznam objednávek', '/orders', 'OrdersList');
  };

  const handleOpenUsers = () => {
    openTab('users', 'Uživatelé a role', '/users', 'UserManagement');
  };

  const handleOpenCustomers = () => {
    openTab('customers', 'Zákazník', '/customers', 'CustomerManagement');
  };

  const handleOpenMediaPricelist = () => {
    openTab('media-pricelist', 'Média a ceníky', '/media-pricelist', 'MediaPricelist');
  };

  const handleOpenInvoices = () => {
    openTab('invoices', 'Fakturace', '/invoices', 'InvoiceList');
  };

  const handleOpenSpiglovani = () => {
    openTab('spiglovani', 'Špíglování', '/spiglovani', 'Spiglovani');
  };

  const handleOpenStatistics = () => {
    openTab('statistics', 'Statistiky', '/statistics', 'Statistics');
  };

  return (
    <>
      <h1 className="h5 mb-4">Dashboard</h1>

      <div className="row g-3 mb-4">
        <div className="col-6 col-md-3">
          <div className="card card-tile h-100">
            <div className="card-body">
              <div className="icon">
                <i className="bi bi-key" />
              </div>
              <div className="label">Žádosti o reset hesla</div>
              <div className="value">0</div>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="card card-tile h-100">
            <div className="card-body">
              <div className="icon">
                <i className="bi bi-shield-check" />
              </div>
              <div className="label">Změny rolí ke schválení</div>
              <div className="value">0</div>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="card card-tile h-100">
            <div className="card-body">
              <div className="icon">
                <i className="bi bi-people" />
              </div>
              <div className="label">Aktivní uživatelé dnes</div>
              <div className="value">0</div>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="card card-tile h-100">
            <div className="card-body">
              <div className="icon">
                <i className="bi bi-door-closed" />
              </div>
              <div className="label">Neúspěšná přihlášení (24 h)</div>
              <div className="value">0</div>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-3 mb-5">
        <div className="col-md-6">
          <div className="card card-tile h-100">
            <div className="card-body">
              <div className="label">Audit — poslední změny</div>
              <div className="small-muted mt-2">Žádné poslední změny k zobrazení.</div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card card-tile h-100">
            <div className="card-body">
              <div className="label">Notifikace</div>
              <div className="small-muted mt-2">Žádné notifikace k zobrazení.</div>
            </div>
          </div>
        </div>
      </div>

      <section className="mb-2">
        <h2 className="h6 mb-3">Hlavní moduly</h2>
        <div className="row g-3 mega-links">
          {can('invoice.view') && (
            <div className="col-6 col-md-4 col-lg-3">
              <a href="#" onClick={(e) => { e.preventDefault(); handleOpenInvoices(); }}>
                <div className="mega-emoji mb-3"><i className="bi bi-receipt" style={{fontSize: '2rem', color: '#00427A'}} /></div>
                <div className="mega-title">Fakturace</div>
                <div className="mega-sub">Faktury, zálohy, exporty</div>
              </a>
            </div>
          )}
          {can('spigl.view') && (
            <div className="col-6 col-md-4 col-lg-3">
              <a href="#" onClick={(e) => { e.preventDefault(); handleOpenSpiglovani(); }}>
                <div className="mega-emoji mb-3"><i className="bi bi-grid-3x3" style={{fontSize: '2rem', color: '#00427A'}} /></div>
                <div className="mega-title">Špíglování</div>
                <div className="mega-sub">Layout, validace, rozložení</div>
              </a>
            </div>
          )}
          {can('crm.view') && (
            <div className="col-6 col-md-4 col-lg-3">
              <a href="#" onClick={(e) => { e.preventDefault(); handleOpenCustomers(); }}>
                <div className="mega-emoji mb-3"><i className="bi bi-building" style={{fontSize: '2rem', color: '#00427A'}} /></div>
                <div className="mega-title">CRM</div>
                <div className="mega-sub">Firmy, kontakty, obchodníci</div>
              </a>
            </div>
          )}
          {can('order.view') && (
            <div className="col-6 col-md-4 col-lg-3">
              <a href="#" onClick={(e) => { e.preventDefault(); handleOpenOrders(); }}>
                <div className="mega-emoji mb-3"><i className="bi bi-cart" style={{fontSize: '2rem', color: '#00427A'}} /></div>
                <div className="mega-title">Objednávky</div>
                <div className="mega-sub">Položky, sleva/provize, schválení</div>
              </a>
            </div>
          )}
          {can('statistics.view') && (
            <div className="col-6 col-md-4 col-lg-3">
              <a href="#" onClick={(e) => { e.preventDefault(); handleOpenStatistics(); }}>
                <div className="mega-emoji mb-3"><i className="bi bi-graph-up" style={{fontSize: '2rem', color: '#00427A'}} /></div>
                <div className="mega-title">Statistiky</div>
                <div className="mega-sub">Provize, sestavy, uzávěrky</div>
              </a>
            </div>
          )}
          {can('media.view') && (
            <div className="col-6 col-md-4 col-lg-3">
              <a href="#" onClick={(e) => { e.preventDefault(); handleOpenMediaPricelist(); }}>
                <div className="mega-emoji mb-3"><i className="bi bi-newspaper" style={{fontSize: '2rem', color: '#00427A'}} /></div>
                <div className="mega-title">Média a ceníky</div>
                <div className="mega-sub">Tituly, mutace, ceníky</div>
              </a>
            </div>
          )}
          {can('users.manage') && (
            <div className="col-6 col-md-4 col-lg-3">
              <a href="#" onClick={(e) => { e.preventDefault(); handleOpenUsers(); }}>
                <div className="mega-emoji mb-3"><i className="bi bi-people" style={{fontSize: '2rem', color: '#00427A'}} /></div>
                <div className="mega-title">Uživatelé & Role</div>
                <div className="mega-sub">Účty, oprávnění, deaktivace</div>
              </a>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default Dashboard;
